<div [hidden]="!ViewReady">
    <h1 class="mat-h1">Cabinet Members & Other Staff</h1>
    <div>
        The following table lists the currently active / defined cabinet members and other staff for the IRIS System. These individuals
        are the staff members who an IRIS facilitator will be able to assign a new request in the IRIS System to for handling. These
        staff members are assigned to one or more categories using the Category Tool in the IRIS System Settings menu. You may use the
        tools provided below to add a new staff member to this list or remove an existing staff member from this list.
    </div>
    <br />
    <div>
        Note: Removing a staff member from this list will <u>not</u> affect their ability to use IRIS to respond to requests forwarded
        to them - only whether or not they can be the first responders to a request forwarded by an IRIS facilitator.
    </div>
    <button type="button" mat-raised-button color="primary" (click)="ShowCabinetMemberForm()">Add New Cabinet Member</button>
    <table class="fullwidth" *ngIf="!SmallDisplay" mat-table [dataSource]="CabinetMembersSource" matSort matSortActive="LastName">
        <ng-container matColumnDef="LastName">
            <th mat-header-cell mat-sort-header *matHeaderCellDef>Last Name</th>
            <td mat-cell *matCellDef="let cab">
                <div>{{ cab.LastName | titleCase }}</div>
            </td>
        </ng-container>

        <ng-container matColumnDef="FirstName">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>First Name</th>
            <td mat-cell *matCellDef="let cab">
                <div>{{ cab.FirstName | titleCase }}</div>
            </td>
        </ng-container>

        <ng-container matColumnDef="SAPID">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>SAP #</th>
            <td mat-cell *matCellDef="let cab">
                <div>{{ cab.SAPID }}</div>
            </td>
        </ng-container>

        <ng-container matColumnDef="LocalJobTitle">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Title</th>
            <td mat-cell *matCellDef="let cab">
                <div>{{ cab.LocalJobTitle }}</div>
            </td>
        </ng-container>

        <ng-container matColumnDef="Type">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Type</th>
            <td mat-cell *matCellDef="let cab">
                <div>{{ cab.Type | cabinetType }}</div>
            </td>
        </ng-container>

        <ng-container matColumnDef="Active">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>In Use?</th>
            <td mat-cell *matCellDef="let cab">
                <div>{{ cab.Active | yesNo }}</div>
            </td>
        </ng-container>

        <ng-container matColumnDef="Actions">
            <th mat-header-cell *matHeaderCellDef>Action(s)</th>
            <td mat-cell *matCellDef="let cab">
                <button
                    type="button"
                    *ngIf="cab.Active !== true && cab.Type !== 'SUPER'"
                    mat-raised-button
                    color="warn"
                    (click)="RemoveCabinetMember(cab)"
                >
                    Remove
                </button>
            </td>
        </ng-container>

        <ng-container matColumnDef="NoData">
            <th mat-header-cell *matHeaderCellDef></th>
            <td mat-cell *matCellDef="let cab" [attr.colspan]="VisibleHeaders?.length">
                <em>There are no cabinet members defined and/or active in the IRIS system at this time.</em>
            </td>
        </ng-container>

        <ng-container matColumnDef="SmallDisplay">
            <th mat-header-cell *matHeaderCellDef>Cabinet Members</th>
            <td mat-cell *matCellDef="let cab">
                <div fxLayout="column" fxLayoutAlign="start stretch">
                    <div fxLayout="row" fxLayoutAlign="space-between start">
                        <div>Last Name</div>
                        <div>{{ cab.LastName | titleCase }}</div>
                    </div>
                    <div fxLayout="row" fxLayoutAlign="space-between start">
                        <div>First Name</div>
                        <div>{{ cab.FirstName | titleCase }}</div>
                    </div>
                    <div fxLayout="row" fxLayoutAlign="space-between start">
                        <div>SAP #</div>
                        <div>{{ cab.SAPID }}</div>
                    </div>
                    <div fxLayout="row" fxLayoutAlign="space-between start">
                        <div>Title</div>
                        <div>{{ cab.LocalJobTitle }}</div>
                    </div>
                    <div fxLayout="row" fxLayoutAlign="space-between start">
                        <div>Type</div>
                        <div>{{ cab.Type | cabinetType }}</div>
                    </div>
                    <div fxLayout="row" fxLayoutAlign="space-between start">
                        <div>In Use?</div>
                        <div>{{ cab.Active | yesNo }}</div>
                    </div>
                    <div fxLayout="column" fxLayoutAlign="start center" fxLayoutGap="15px">
                        <button
                            type="button"
                            *ngIf="cab.Active !== true && cab.Type !== 'SUPER'"
                            mat-raised-button
                            color="warn"
                            (click)="RemoveCabinetMember(cab)"
                        >
                            Remove
                        </button>
                    </div>
                </div>
            </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="VisibleHeaders"></tr>
        <tr
            mat-row
            *matRowDef="let row; columns: VisibleColumns; let $even = even"
            [class.primarybackground50]="$even && !!row.Active"
            [class.inactive]="!row.Active"
        ></tr>
    </table>

    <mat-paginator [pageSizeOptions]="[5, 10, 20, 50]" [pageSize]="20" [length]="CabinetMembersSource?.data?.length"></mat-paginator>
</div>
